export default __webpack_public_path__ + "static/tribalBooks_logo-8a604d8118aa52f350c32589dee5dca8.png";